import { Config as FinalFormConfig } from 'final-form';
import { FC } from 'react';

import TitleBlock from '../TitleBlock';
import ChangePasswordForm from '../form/ChangePasswordForm';

export type ChangePasswordBlockProps = {
  onSubmit: FinalFormConfig['onSubmit'];
  isPending?: boolean;
  submitError?: string | null;
};

const ChangePasswordBlock: FC<ChangePasswordBlockProps> = ({
  onSubmit,
  isPending,
  submitError
}) => (
  <div>
    <TitleBlock level={3} title="Change your password" size="medium" />
    <ChangePasswordForm
      onSubmit={onSubmit}
      isPending={isPending}
      submitError={submitError}
    />
  </div>
);

export default ChangePasswordBlock;
